import {Component, OnDestroy, OnInit, ViewChild} from "@angular/core";
import {GEF_FLUX_DISPONIBLE, GEF_PROVIDER, MSG_KEY, MSG_SEVERITY} from "../../../../core/constants";
import {SiteDTO} from "../../../../core/dtos/site-dto";
import {Subscription} from "rxjs";
import {GefConnectionDto} from "../../../../core/dtos/gef/gef-connection-dto";
import {FormControl, FormGroup} from "@angular/forms";
import {Auth2Service} from "../../../../core/services/security/auth2.service";
import {ToastService} from "../../../../core/services/technique/toast.service";
import {UtilsService} from "../../../../core/utils/utils.service";
import {GestionGefService} from "../../../../core/services/gef/gestion-gef.service";
import {LookUpComponent} from "../../../../shared/ui/lookup/lookup.component";
import {GefProviderDto} from "../../../../core/dtos/gef/gef-provider-dto";
import {BoncfStatutDTO} from "../../../../core/dtos/boncf-statut-d-t-o";
import {confirm} from "devextreme/ui/dialog";
import {ButtonThemeEnum} from '../../../../shared/ui/button/button-theme-enum';
import {GefElapFinanceFormComponent} from './providers/gef-elap-finance-form/gef-elap-finance-form.component';
import {GefDolApiFormComponent} from './providers/gef-dol-api-form/gef-dol-api-form.component';


@Component({
  selector: 'yo-connections-gef-config-edition-dialog',
  templateUrl: './connections-gef-config-edition-dialog.component.html',
  styleUrls: ['./connections-gef-config-edition-dialog.component.scss'],
  standalone: false
})
export class ConnectionsGefConfigEditionDialogComponent implements OnInit, OnDestroy {

  public readonly ButtonThemeEnum = ButtonThemeEnum;
  public readonly GEF_PROVIDER = GEF_PROVIDER;

  @ViewChild('siteLookup') siteLookup: LookUpComponent;
  @ViewChild('gefProvidersLookup') gefProvidersLookup: LookUpComponent;
  @ViewChild(GefElapFinanceFormComponent) elapFinanceForm?: GefElapFinanceFormComponent;
  @ViewChild(GefDolApiFormComponent) dolApiForm?: GefDolApiFormComponent;

  gefProviders: GefProviderDto[] = [];
  bonCfStatutExportlist: BoncfStatutDTO[] = [];
  fluxList: any[] = [];

  dialogTitle: string;
  displayDialog = false;

  form: FormGroup = new FormGroup({actif: new FormControl()});

  sitePlaceholder: String = 'Sélectionner le site...';
  idSelectedSite: number;
  idSelectedGefProvider: number;
  selectedFlux: number[] = [];

  subOpenDialog: Subscription;
  subFindAllGefProviders: Subscription;
  subFindAllBonCfStatus: Subscription;

  gefConnection: GefConnectionDto;

  constructor(private auth2Svc: Auth2Service,
              private toastSvc: ToastService,
              private gestionGefSvc: GestionGefService,
              public utilsSvc: UtilsService) {
  }

  ngOnInit() {
    this.initData();
    this.openDialogEditionSubscription();
  }

  ngOnDestroy(): void {
    this.utilsSvc.unsubscribe(this.subOpenDialog);
    this.utilsSvc.unsubscribe(this.subFindAllGefProviders);
    this.utilsSvc.unsubscribe(this.subFindAllBonCfStatus);
  }

  openDialogEditionSubscription = (): void => {
    this.subOpenDialog = this.gestionGefSvc.openGefConnectionFluxEditionDialog
      .subscribe((connection: GefConnectionDto) => {
        this.displayDialog = true;
        if (!connection) {
          this.gefConnection = new GefConnectionDto();
          this.gefConnection.id = null;
          this.dialogTitle = 'Création d\'une configuration GEF';
        } else {
          this.gefConnection = connection;
          this.dialogTitle = 'Modification d\'une configuration GEF';
          this.idSelectedGefProvider = this.gefProviders.find(gp => gp.code === this.gefConnection?.gefProvider?.code)?.id;
        }
        this.initForm();
      });
  };

  findAllLocalSites = (): SiteDTO[] => {
    return this.auth2Svc.utilisateur.siteListLocaux;
  }

  findAllBonCfStatus() {
    this.subFindAllBonCfStatus = this.gestionGefSvc.findAllBonCfStatus('ASC').subscribe(result => {
      this.bonCfStatutExportlist = result.allBonCfStatus;
    });
  }

  initData = (): void => {
    this.subFindAllGefProviders = this.gestionGefSvc.findAllGefProviders().subscribe(result => {
      this.gefProviders = result.allGefProviders;
      if (this.gefProviders.length === 1) {
        this.idSelectedGefProvider = this.gefProviders[0].id;
      }
    });
    this.findAllBonCfStatus();
    this.initFluxList();
  }

  initFluxList = (): void => {
    this.fluxList = Object.entries(GEF_FLUX_DISPONIBLE).map(([key, value], index) => ({
      id: index,
      code: key,
      libelle: value
    }));
  }

  initForm = (): void => {
    this.sitePlaceholder = !this.canModify() ? this.gefConnection?.site?.libelle : 'Sélectionner le site...';
    this.idSelectedSite = this.gefConnection?.site?.id;
    this.selectedFlux = this.fluxList.filter(f => this.gefConnection?.gefFluxList?.includes(f.code)).map(f => f.id);
    this.form = new FormGroup({actif: new FormControl(this.gefConnection?.actif)});
  };

  async save() {
    if (!this.form.valid) {
      this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.ERROR, `Veuillez compléter le formulaire`);
      return;
    }

    const saveGefConnection: GefConnectionDto = {...this.gefConnection};
    saveGefConnection.site = {
      id: this.siteLookup.getSelectedItem().id,
      libelle: this.siteLookup.getSelectedItem().libelle
    } as SiteDTO;
    saveGefConnection.gefProvider = this.gefProviders.find(gp => gp.id === this.idSelectedGefProvider);
    saveGefConnection.gefFluxList = this.fluxList.filter(flux => this.selectedFlux.includes(flux.id)).map(flux => flux.code);

    const confirmed = await this.checkFluxSelection(saveGefConnection.gefFluxList);
    if (!confirmed) { return; }

    saveGefConnection.actif = this.form.controls['actif'].value;
    const activeForm = this.elapFinanceForm ?? this.dolApiForm;
    saveGefConnection.jsonProperties = activeForm?.buildJsonProperties() ?? {};
    saveGefConnection.properties = null;

    this.gestionGefSvc.save(saveGefConnection)
      .subscribe(res => {
        if (res && res.one) {
          const isUpdate = saveGefConnection.id !== null && saveGefConnection.id !== undefined && saveGefConnection.id !== 0;
          this.gestionGefSvc.announceGefConnectionSaved(res.one, isUpdate);
          this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS, `Sauvegarde de la connection à la GEF réalisée avec succès`);
          this.closeDialog();
        }
      });
  }

  canModify() {
    return this.gestionGefSvc.canModify(this.gefConnection);
  }

  onChangeSite = ($event: any): void => {
    this.idSelectedSite = $event;
  }

  onChangeGefProvider = ($event: any): void => {
    this.idSelectedGefProvider = $event;
    this.initFluxList();
    this.fluxList = this.fluxList.filter(f => f.code.startsWith(this.gefProviders.find(gp => gp.id === this.idSelectedGefProvider)?.code));
  }

  isGefProviderSelected(gefProviderExpected: string) {
    return this.idSelectedGefProvider != null
      ? this.idSelectedGefProvider === this.gefProviders.find(p => p.code === gefProviderExpected)?.id
      : false;
  }

  onSelectedFluxChange($event: any) {
    this.selectedFlux = $event;
  }

  checkFluxSelection = async (rowsSelected: String[]): Promise<boolean> => {
    const removedItems = this.gefConnection.gefFluxList.filter(item => !rowsSelected.includes(item));
    if (removedItems.length > 0) {
      const message = removedItems.length > 1
        ? 'Voulez-vous vraiment supprimer ces flux de votre configuration (' + removedItems + ')'
        : 'Voulez-vous vraiment supprimer ce flux de votre configuration (' + removedItems + ')';
      return confirm(message + '.</br> L\'historique GEF entre ce flux et votre interface sera définitivement supprimé.', 'Suppression de flux GEF');
    }
    return true;
  }

  closeDialog() {
    this.displayDialog = false;
  }
}
